import { useDispatch } from "react-redux";
import { setTimeSessionToken } from "../actions/manageSessionsAction";

const useSession = () => {
    const dispatch = useDispatch();
    const saveTimeLeft = async (time) => {
        try {
            await dispatch(setTimeSessionToken(time));
        } catch (err) {
            throw err; 
        }
    };

    return {
        saveTimeLeft
    }
};

export default useSession;
